import React, { ComponentProps } from "react";
import * as S from "./styles";
import { InputRHF } from "../../Atoms/InputsRHF/InputRHF";
import { MessageErroForm } from "../../Atoms/MessageErroForm";
import { useFormLogin } from "./useFormLogin";
import { IAutenticacaoForm } from "../../../types/autenticacao";
import { CardRouded } from "../../Atoms/CardRounded";
import { ButtonV2 } from "../../Atoms/ButtonV2";

interface IFormLoginProps extends ComponentProps<"form"> {
  onSubmitForm: (data: IAutenticacaoForm) => void;
}

export const FormLogin = ({ onSubmitForm, ...rest }: IFormLoginProps) => {
  const { errors, handleSubmit, navigate, register } = useFormLogin();

  return (
    <div>
      <CardRouded className="max-w-[400px] mx-auto mb-6 md:mb-8">
        <S.Form {...rest} onSubmit={handleSubmit(onSubmitForm)}>
          <div>
            <InputRHF
              {...register("cpfCNPJ")}
              label="CPF/ CNPJ"
              id="login"
              required
              maxLength={18}
            />

            {errors?.cpfCNPJ?.message && (
              <MessageErroForm>{errors?.cpfCNPJ?.message}</MessageErroForm>
            )}
          </div>
          <div>
            <InputRHF
              {...register("senha")}
              label="Senha"
              required
              id="password"
              type="password"
            />

            {errors?.senha?.message && (
              <MessageErroForm>{errors?.senha?.message}</MessageErroForm>
            )}
          </div>

          <ButtonV2
            className="ml-auto my-4"
            variant="underline"
            type="button"
            onClick={() => navigate("/recuperar-senha")}
          >
            Esqueceu sua senha?
          </ButtonV2>

          <div className="flex flex-col gap-4">
            <ButtonV2 className="w-full">
              Entrar
              <img
                src="/assets/svgs/icon-arrow-forward.svg"
                alt="seta para a direita"
              />
            </ButtonV2>
            <ButtonV2
              className="w-full"
              type="button"
              variant="text"
              onClick={() => navigate(-1)}
            >
              <img
                src="/assets/svgs/icon-arrow-back-red.svg"
                alt="seta voltar"
              />
              Voltar
            </ButtonV2>
          </div>
        </S.Form>
      </CardRouded>

      <div className="flex items-center mx-auto w-fit">
        <p>Não possui acesso? </p>
        <ButtonV2
          variant="underline"
          onClick={() => navigate("/agendamento/auth/cadastro-usuario")}
        >
          Cadastre-se aqui
        </ButtonV2>
      </div>
    </div>
  );
};
